function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgDonationsCard = function SvgDonationsCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18045_373142)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_18045_373142)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 41.1709,
    width: 40.3411,
    height: 64,
    rx: 9,
    transform: "rotate(-90 0 41.1709)",
    fill: "#070707",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    y: 41.1709,
    width: 40.3411,
    height: 64,
    rx: 9,
    transform: "rotate(-90 0 41.1709)",
    fill: "url(#paint0_radial_18045_373142)"
  })), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.48,
    x: 45,
    y: 7,
    width: 8.37209,
    height: 8.37209,
    rx: 4.18605,
    fill: "#BD0000"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 50.0547,
    y: 7,
    width: 8.37209,
    height: 8.37209,
    rx: 4.18605,
    fill: "#DCC600"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_18045_373142)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.42773,
    y: 14.3643,
    width: 8.49612,
    height: 6.07752,
    rx: 1.08527,
    fill: "url(#paint1_linear_18045_373142)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.41797 16.4677H10.3071C10.49 15.9059 11.0043 14.7484 11.5983 14.6123C11.8189 14.6896 12.3343 14.9679 12.6313 15.4627M7.41797 18.4159H10.3071C10.3071 19.3807 11.1679 20.0858 11.5983 20.3177C12.3214 20.0827 12.8787 18.9519 13.067 18.4159H15.9239M15.9239 16.9316H13.067C12.9379 16.6893 12.7572 16.1307 13.067 15.8338",
    stroke: "url(#paint2_linear_18045_373142)",
    strokeWidth: 0.0930233
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6504 17.1707C18.7537 17.3568 18.8985 17.8157 18.6504 18.163M19.3326 16.8141C19.4876 17.1087 19.7047 17.8622 19.3326 18.5196M19.9372 16.442C20.1388 16.84 20.4209 17.8777 19.9372 18.8451M20.5884 16.1475C20.8468 16.6177 21.2085 17.8746 20.5884 19.1397",
    stroke: "white",
    strokeWidth: 0.341085,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_18045_373142",
    x: -7.75194,
    y: -6.92235,
    width: 79.5039,
    height: 55.8452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 3.87597
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_18045_373142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_18045_373142",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.0620155,
    dy: -0.0620155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0465116
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_18045_373142"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.155039,
    dy: 0.124031
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0620155
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_18045_373142",
    result: "effect3_innerShadow_18045_373142"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_18045_373142",
    x: 7.42773,
    y: 14.3643,
    width: 8.49609,
    height: 6.07764,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.0930233,
    dy: -0.0930233
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18045_373142"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18045_373142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.25581 40.2717) rotate(60.0023) scale(70.1755 44.2337)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18045_373142",
    x1: 7.42773,
    y1: 14.3643,
    x2: 15.0401,
    y2: 20.4418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18045_373142",
    x1: 7.73782,
    y1: 14.7053,
    x2: 15.3502,
    y2: 20.1627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18045_373142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 40.3411,
    fill: "white",
    transform: "translate(0 0.82959)"
  }))));
};
export default SvgDonationsCard;